/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-15 17:11:46
 */
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { QuestionCircleTwoTone } from '@ant-design/icons'
import { SupplierModal } from '../../savebusiness/modal'
import { unwrapResult } from '@reduxjs/toolkit'
import { SupplierModal as SupplierSaveModal } from '../../wms/modal'
import {
  getBatchDrugQualityFileSubmitAsync,
  getDrugQualityFileSubmitAsync,
} from './drugQualityFileSlice'
import { setCurrent, setSelectId } from '../../wms/supplierSlice'

const { Option } = Select

export const BatchAddFormModal = (props: {
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [ismodalVisible, setIsmodalVisible] = useState(false)

  const [tenantSupplierId, setTenantSupplierId] = useState(0)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [flag, setFlag] = useState<any>()

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  useEffect(() => {
    if (props.isModalVisible) {
      form.setFieldsValue({
        appearanceQuality: '1',
      })
    } else {
      form.resetFields()
    }
  }, [props.isModalVisible])

  return (
    <>
      <Modal
        width={1200}
        title={'批量添加数据'}
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            setConfirmLoading(true)
            const params = {
              ...vs,
              tenantSupplierId: tenantSupplierId ? tenantSupplierId : undefined,
            }
            dispatch(getBatchDrugQualityFileSubmitAsync({ ...params }))
              .then(unwrapResult)
              .then((v: any) => {
                if (v == 0) {
                  notification.info({
                    message: '药品已全部添加，无需再次添加',
                  })
                } else {
                  notification.success({
                    message: '操作成功',
                  })
                }
                props?.onOk()
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={8}>
              <Form.Item {...layout} label='储存条件' name='putWay'>
                <Input placeholder='储存条件' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='外观质量' name='appearanceQuality'>
                <Select placeholder='外观质量' allowClear>
                  <Option value='1'>合格</Option>
                  <Option value='0'>不合格</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='规范情况' name='normSituation'>
                <Input placeholder='规范情况' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='进货质量评审情况'
                name='instockSituation'
              >
                <Input placeholder='进货质量评审情况' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='顾客质量评价' name='customRemark'>
                <Input placeholder='顾客质量评价' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} name='supplierName' label='供应商'>
                <Input
                  size='middle'
                  allowClear
                  onClick={() => {
                    setFlag(0)
                    setIsModalVisible(true)
                  }}
                  addonAfter={
                    <>
                      <Popover
                        content={
                          <div>
                            <p>
                              设置常用供应商后，您可以通过入库/申领/采购等环节设置的供应商快速找到这个药品。
                            </p>
                          </div>
                        }
                        placement='top'
                        title='说明'
                      >
                        <QuestionCircleTwoTone />
                      </Popover>
                    </>
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='备注' name='remark'>
                <Input placeholder='备注' />
              </Form.Item>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              loading={confirmLoading}
              type='primary'
              onClick={() => {
                form.submit()
              }}
              style={{ marginRight: '10px' }}
            >
              确定
            </Button>
            <Button
              type='primary'
              ghost
              style={{ marginRight: '10px' }}
              onClick={() => {
                props?.onCancel()
              }}
            >
              取消
            </Button>
          </Row>
        </Form>
      </Modal>
      {/* 生产厂家 supplierCategory=1  供应商 supplierCategory=0*/}
      <SupplierModal
        supplierCategory={flag}
        visible={isModalVisible}
        switchModal={() => {
          setIsModalVisible(false)
          setIsmodalVisible(true)
        }}
        onOk={() => {
          setIsModalVisible(false)
          setFlag('')
        }}
        onCancel={() => {
          setIsModalVisible(false)
          setFlag('')
        }}
        onRecord={(record: any) => {
          setTenantSupplierId(record.id)
          form.setFieldsValue({
            supplierName: record.companyName,
          })
        }}
      />
      <SupplierSaveModal
        visible={ismodalVisible}
        supplierCategory={flag}
        onOk={() => {
          setIsmodalVisible(false)
          dispatch(setCurrent(1))
          setIsModalVisible(true)
          dispatch(setSelectId(0))
        }}
        onCancel={() => {
          setIsmodalVisible(false)
          setIsModalVisible(true)
          dispatch(setSelectId(0))
        }}
      />
    </>
  )
}
